var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.6402 3.03349C10.2693 2.72445 9.73066 2.72445 9.35982 3.03349L2.5 8.75V17.5H7.5V12.5H12.5V17.5H17.5V8.75L10.6402 3.03349Z","fill":"#409EFF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }